import { render, staticRenderFns } from "./QSummitHomePageBirds.vue?vue&type=template&id=499b9b19&"
var script = {}
import style0 from "./QSummitHomePageBirds.vue?vue&type=style&index=0&id=499b9b19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports